var exports = {
  "kL": "AppDetailModal.module__container___QUl6Rl",
  "vK": "AppDetailModal.module__banner___QUl6Rl",
  "VW": "AppDetailModal.module__headerContent___QUl6Rl",
  "R3": "AppDetailModal.module__avatarWrapper___QUl6Rl",
  "my": "AppDetailModal.module__avatar___QUl6Rl",
  "HE": "AppDetailModal.module__verifiedCheck___QUl6Rl",
  "uu": "AppDetailModal.module__actionButtons___QUl6Rl",
  "_o": "AppDetailModal.module__installBtn___QUl6Rl",
  "cP": "AppDetailModal.module__titleSection___QUl6Rl",
  "JB": "AppDetailModal.module__appName___QUl6Rl",
  "dS": "AppDetailModal.module__tagline___QUl6Rl",
  "KW": "AppDetailModal.module__metaRow___QUl6Rl",
  "Ho": "AppDetailModal.module__metaItem___QUl6Rl",
  "AZ": "AppDetailModal.module__categoryBadge___QUl6Rl",
  "$H": "AppDetailModal.module__tabBar___QUl6Rl",
  "V3": "AppDetailModal.module__tabItem___QUl6Rl",
  "xy": "AppDetailModal.module__tabItemActive___QUl6Rl",
  "kQ": "AppDetailModal.module__bodyContent___QUl6Rl",
  "ij": "AppDetailModal.module__descriptionText___QUl6Rl",
  "bV": "AppDetailModal.module__sectionHeader___QUl6Rl",
  "mR": "AppDetailModal.module__linksList___QUl6Rl",
  "uZ": "AppDetailModal.module__externalLink___QUl6Rl",
  "$Q": "AppDetailModal.module__commandsList___QUl6Rl",
  "Lr": "AppDetailModal.module__commandItem___QUl6Rl",
  "p6": "AppDetailModal.module__commandName___QUl6Rl",
  "D6": "AppDetailModal.module__commandDesc___QUl6Rl",
  "bJ": "AppDetailModal.module__tagPills___QUl6Rl",
  "uU": "AppDetailModal.module__tagPill___QUl6Rl",
};

module.exports = exports;
